// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__QgVqp","link":"Navbar_link__teYe1","logo":"Navbar_logo__INhgK"};